export default __webpack_public_path__ + "static/media/pen.bbd7c82a.svg";